var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',_vm._g(_vm._b({staticClass:"icon material-icons",style:(_vm.iconSize)},'i',_vm.$attrs,false),_vm.$listeners),[_vm._v(_vm._s(_vm.name))])}
var staticRenderFns = []

export { render, staticRenderFns }